/* eslint-disable import/prefer-default-export */

const axios = require('axios').default;
import { toastError } from '../../../shared/toastHelper';
import {
  VENUE_SELECTED_CHANGED,
  EVENTS_CHANGED,
  CALENDAR_EVENT_CONFLICTS_CHANGED,
  OPEN_CALENDAR_EVENT_CONFLICTS_MODAL,
  CLOSE_CALENDAR_EVENT_CONFLICTS_MODAL,
  USER_UPDATED,
  CALENDAR_EVENT_CONFLICTS_MERGE_CHECKBOX_CLICKED,
  TOGGLE_ON_SALE_ENABLED,
  TOGGLE_PRE_SALE_ENABLED,
  TOGGLE_ARTIST_PRE_SALE_ENABLED,
  TOGGLE_ANNOUNCED_ENABLED,
  TOGGLE_CONFIRMED_ENABLED,
  TOGGLE_HOLDS_ENABLED,
  TOGGLE_PAST_EVENTS_ENABLED,
  TOGGLE_CANCELLED_EVENTS_ENABLED,
  CALENDAR_REF_UPDATED,
  CALENDAR_START_DATE_UPDATED,
  MONTH_VIEW_CHANGED,
  DATA_TABLE_FILTERS_CHANGED,
  RELOAD_DATA_TABLE,
  DATA_TABLE_EL_CHANGED,
  SEARCH_TERM_CHANGED,
  CURRENT_TEAM_MEMBERSHIP_CHANGED,
  CHECK_AVAILS_IS_OPEN_CHANGED,
  CHECK_AVAILS_SETTINGS_CHANGED,
  CALENDAR_SYNC_IS_OPEN_CHANGED,
  CLASSIFICATION_TOTALS_CHANGED,
  CHECK_AVAILS_DATES_CHANGED,
  CHECK_AVAILS_CALENDAR_EVENTS_CHANGED,
  CHECK_AVAILS_LOADING_CHANGED
} from '../constants/calendarViewConstants';

import {
  utcToTimeZone
} from '../../../shared/timeZoneLogic';

export const updateSelectedVenue = (venues, selected) => ({
  type: VENUE_SELECTED_CHANGED,
  venues,
  selected
});

export const fetchCalendarEventsForSelectedVenues = (dispatch, team, selectedRooms, selectedTags) => {
  return (dispatch, getState) => {
    var calendarView = getState().calendarView;

    if(!calendarView){
      return;
    }

    return axios.get("/teams/" + team.id + "/calendar_events", {
        params: {
          tags: selectedTags,
          room_ids: selectedRooms.map((s) => s.value),
          start_of_month: calendarView.calendarStartDate,
          time_zone: "UTC"
        }
      })
      .then(({ data }) => {
        let localizedEvents = data.calendar_events.map((event) => {
          return {
            ...event,
            start: (event.date ? utcToTimeZone(event.date, event.time_zone) : null),
            end: (event.end ? utcToTimeZone(event.end, event.time_zone) : null),
            date_range: event.date_range.map((d) => utcToTimeZone(d, event.time_zone))
          };
        });

        dispatch(updateAllEvents(localizedEvents));
        dispatch(classificationTotalsChanged(data.totals));
      })
  };
};

export const updateAllEvents = (events) => ({
  type: EVENTS_CHANGED,
  events
});

export const fetchTeamVenueConflicts = (dispatch, team, selectedRooms, user) => {
  return dispatch => {
    if(!user.can_manage_calendar_event_conflicts){
      return;
    }

    return axios.get("/teams/" + team.id + "/calendar_event_conflicts", {
        params: {
          room_ids: selectedRooms.map((s) => s.value)
        }
      })
      .then(({ data }) => {
        data.map((calendarEventConflict) => {
          calendarEventConflict.shouldMerge = true;
        });

        dispatch(calendarEventConflictsChanged(data));

        if(data.length > 0){
          dispatch(openCalendarEventConflictsModal());
        }
      })
  }
};

export const onInit = (dispatch, team, selectedRooms, selectedTags, user, dataTableFilters, monthView) => {
  dataTableFilters = Object.assign({}, dataTableFilters, {
    room_ids: selectedRooms.map((s) =>  s.value),
    tags: selectedTags,
  });

  return dispatch => {
    // If the user loads the page in list view, we need to fetch the CalendarEvents
    // to power the classification filter totals.
    if(!monthView){
      dispatch(fetchCalendarEventsForSelectedVenues(dispatch, team, selectedRooms, selectedTags));
    }

    dispatch(fetchTeamVenueConflicts(dispatch, team, selectedRooms, user));
    dispatch(dataTableFiltersChanged(dataTableFilters));
  }
};

export const calendarEventConflictsChanged = (calendarEventConflicts) => ({
  type: CALENDAR_EVENT_CONFLICTS_CHANGED,
  calendarEventConflicts
});

export const openCalendarEventConflictsModal = () => ({
  type: OPEN_CALENDAR_EVENT_CONFLICTS_MODAL
});

export const closeCalendarEventConflictsModal = () => ({
  type: CLOSE_CALENDAR_EVENT_CONFLICTS_MODAL
});

export const confirmTeamVenueConflicts = (dispatch, csrfToken, team, calendarEventConflicts, selectedRooms, selectedTags) => {
  var mapping = calendarEventConflicts.map((calendarEventConflict) => {
    return {
      id: calendarEventConflict.id,
      resolution: (calendarEventConflict.shouldMerge ? "merge" : "ignore")
    };
  });

  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/calendar_event_conflicts/confirm", {
        mapping: mapping
      })
      .then(({ data }) => {
        dispatch(fetchCalendarEventsForSelectedVenues(dispatch, team, selectedRooms, selectedTags));
      })
  }
};

export const saveUserCalendarStartDay = (dispatch, csrfToken, calendarStartDay) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/user_settings", {
        user: {
          calendar_start_day: calendarStartDay
        }
      })
      .then(({ data }) => {
        dispatch(updateUser(data));
      })
  };
};

export const updateUser = (user) => ({
  type: USER_UPDATED,
  user
});

export const calendarEventConflictMergeCheckboxClicked = (calendarEventConflict, checked) => ({
  type: CALENDAR_EVENT_CONFLICTS_MERGE_CHECKBOX_CLICKED,
  calendarEventConflict,
  checked
});

export const toggleOnSaleEnabled = (onSaleEnabled) => ({
  type: TOGGLE_ON_SALE_ENABLED,
  onSaleEnabled
});

export const togglePreSaleEnabled = (preSaleEnabled) => ({
  type: TOGGLE_PRE_SALE_ENABLED,
  preSaleEnabled
});

export const toggleArtistPreSaleEnabled = (artistPreSaleEnabled) => ({
  type: TOGGLE_ARTIST_PRE_SALE_ENABLED,
  artistPreSaleEnabled
});

export const toggleAnnouncedEnabled = (announcedEnabled) => ({
  type: TOGGLE_ANNOUNCED_ENABLED,
  announcedEnabled
});

export const toggleConfirmedEnabled = (confirmedEnabled) => ({
  type: TOGGLE_CONFIRMED_ENABLED,
  confirmedEnabled
});

export const toggleHoldsEnabled = (holdsEnabled) => ({
  type: TOGGLE_HOLDS_ENABLED,
  holdsEnabled
});

export const togglePastEventsEnabled = (pastEventsEnabled) => ({
  type: TOGGLE_PAST_EVENTS_ENABLED,
  pastEventsEnabled
});

export const toggleCancelledEventsEnabled = (cancelledEventsEnabled) => ({
  type: TOGGLE_CANCELLED_EVENTS_ENABLED,
  cancelledEventsEnabled
});

export const calendarRefUpdated = (calendarRef) => ({
  type: CALENDAR_REF_UPDATED,
  calendarRef
})

export const calendarStartDateUpdated = (date) => ({
  type: CALENDAR_START_DATE_UPDATED,
  date
})

export const monthViewChanged = (monthView) => ({
  type: MONTH_VIEW_CHANGED,
  monthView
})

export const dataTableFiltersChanged = (dataTableFilters) => ({
  type: DATA_TABLE_FILTERS_CHANGED,
  dataTableFilters
})

export const reloadDataTable = () => ({
  type: RELOAD_DATA_TABLE
})

export const dataTableElChanged = (el) => ({
  type: DATA_TABLE_EL_CHANGED,
  el
})

export const searchTermChanged = (term) => ({
  type: SEARCH_TERM_CHANGED,
  term
})

export const saveTeamMembershipCalendarState = (dispatch, csrfToken, team, teamMembership, teamMembershipParams) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/team_memberships/" + teamMembership.id, {
        team_membership: teamMembershipParams
      })
      .then(({ data }) => {
        dispatch(currentTeamMembershipChanged(data));
      })
  };
};

export const currentTeamMembershipChanged = (currentTeamMembership) => ({
  type: CURRENT_TEAM_MEMBERSHIP_CHANGED,
  currentTeamMembership
})

export const checkAvailsIsOpenChanged = (checkAvailsIsOpen) => ({
  type: CHECK_AVAILS_IS_OPEN_CHANGED,
  checkAvailsIsOpen
})

export const checkAvailsSettingsChanged = (checkAvailsSettings) => ({
  type: CHECK_AVAILS_SETTINGS_CHANGED,
  checkAvailsSettings
})

export const calendarSyncIsOpenChanged = (calendarSyncIsOpen) => ({
  type: CALENDAR_SYNC_IS_OPEN_CHANGED,
  calendarSyncIsOpen
})

export const classificationTotalsChanged = (classificationTotals) => ({
  type: CLASSIFICATION_TOTALS_CHANGED,
  classificationTotals
})

export const checkAvailsDatesChanged = (checkAvailsDates) => ({
  type: CHECK_AVAILS_DATES_CHANGED,
  checkAvailsDates
})

export const checkAvailsCalendarEventsChanged = (checkAvailsCalendarEvents) => ({
  type: CHECK_AVAILS_CALENDAR_EVENTS_CHANGED,
  checkAvailsCalendarEvents
})

export const fetchCheckAvailsCalendarEvents = (dispatch, team, checkAvailsRooms, checkAvailsDates, signal) => {
  return (dispatch, getState) => {
    dispatch(checkAvailsLoadingChanged(true));

    var adjustedStartDate = new Date(checkAvailsDates[0]);
    adjustedStartDate.setDate(adjustedStartDate.getDate() - 14);

    var adjustedEndDate = new Date(checkAvailsDates[1]);
    adjustedEndDate.setDate(adjustedEndDate.getDate() + 14);

    return axios.get("/teams/" + team.id + "/calendar_events", {
        params: {
          room_ids: checkAvailsRooms.map((room) => room.value),
          start_date: adjustedStartDate,
          end_date: adjustedEndDate,
          time_zone: "UTC"
        },
        signal
      })
      .then(({ data }) => {
        if(signal.aborted){
          return;
        }

        let localizedEvents = data.calendar_events.map((event) => {
          return {
            ...event,
            start: (event.date ? utcToTimeZone(event.date, event.time_zone) : null),
            end: (event.end ? utcToTimeZone(event.end, event.time_zone) : null),
            date_range: event.date_range.map((date) => utcToTimeZone(date, event.time_zone))
          };
        });

        dispatch(checkAvailsCalendarEventsChanged(localizedEvents));
      }, () => {
        if(signal.aborted){
          return;
        }

        toastError("Could not check avails. Please try again.");
      })
      .finally(() => {
        if(signal.aborted){
          return;
        }

        dispatch(checkAvailsLoadingChanged(false));
      });
  };
};

export const checkAvailsLoadingChanged = (checkAvailsLoading) => ({
  type: CHECK_AVAILS_LOADING_CHANGED,
  checkAvailsLoading
})
